import React from 'react';
import {Link} from 'react-router-dom';

import {useSelector} from '../../../state/hooks';
import {type Ref as PanelBankSectionConfigRef} from '../../../state/views/panelBankSectionConfig/types';
import {type LayedOutPanel} from '../../../util/panelTypes';
import {useSharedPanelStateMaybe} from '../SharedPanelStateContext';
import {appendZoomParamsToURL} from '../zoomURLUtils';
import {getSharePanelLink} from './fullScreenUtils';

/**
 * This wraps the react-router-dom Link component so we can navigate to the
 * full screen panel page when triggered.
 */
export const FullScreenPanelLink = ({
  panel,
  panelBankSectionConfigRef,
  children,
}: {
  panel: LayedOutPanel;
  panelBankSectionConfigRef: PanelBankSectionConfigRef | undefined;
  children: React.ReactNode;
}) => {
  const {userZoomState} = useSharedPanelStateMaybe() ?? {};
  const panelBankSectionName = useSelector(state => {
    // We should never hit this state when trying to go full screen in a workspace.
    // Right now, both workspaces and reports share the same panel header, but reports
    // will never have a sectionConfigRef associated. Once panel header is decoupled,
    // we can then remove this check and tighten the types.
    if (panelBankSectionConfigRef == null) {
      return '';
    }

    return state.views.parts[panelBankSectionConfigRef.type][
      panelBankSectionConfigRef.id
    ]?.name;
  });

  let link = getSharePanelLink(panel, panelBankSectionName);
  if (userZoomState) {
    link = appendZoomParamsToURL(link, userZoomState);
  }
  return <Link to={link}>{children}</Link>;
};
